<template>
  <div>
    <div class="page_header">
      <!-- 标题、查询 -->
      <!-- <kl-label :title="title" bold :fontSize="14" style="flex:1"></kl-label> -->
      <span class="page_title" style="flex:1;text-align: left;">{{ title }}</span>
      <el-form inline>
        <el-form-item :label="$t('maintenance.carNo') + '：'">
          <el-input v-model="inputCarNo" :placeholder="$t('maintenance.pleaseEnterTheLicensePlateNumber')" :size="size" clearable></el-input>
        </el-form-item>
        <el-form-item >
          <el-button 
            :size="size"
            type="primary" 
            style="margin-left:10px"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <!-- 登记车辆列表标题 -->
    <div style="display:flex;align-items:center">
      <kl-label :title="$t('maintenance.checkInCarList')" icon="icon-icon_tab_list" bold style="flex:1"></kl-label>
      <div style="font-size:12px">
        <el-link :underline="false" style="margin-right:20px" @click="add"><i class="el-icon-plus" style="height: 16px;width:16px;font-weight:bold"></i> {{$t("public.add")}}</el-link>
        <el-link v-if="showExport" :underline="false" style="margin-right:20px" @click="exportClick"><i class="el-icon-download" style="height: 16px;width:16px;font-weight:bold"></i> {{$t("public.export")}}</el-link>
        <el-link v-if="false" :underline="false" style="margin-right:20px" @click="edit"><i class="iconfont icon-icon_operat_edite" style="height: 16px;width:16px"></i> {{$t("public.edit")}}</el-link>
        <el-link v-if="false" :underline="false" style="margin-right:20px" @click="del"><i class="iconfont icon-icon_operat_delete" style="height: 16px;width:16px"></i> {{$t("public.del")}}</el-link>
      </div>
    </div>
  </div>
</template>
<script>
import KLLabel from '@/components/KLLabel.vue'
export default {
  data(){
    return{
      inputCarNo:"",
    }
  },
  props:{
    title:{
      type:String,
      default:""
    },
    size:{
      type:String,
      default:""
    },
    showExport:{
      type:Boolean,
      default:false
    }
  },
  components:{KLLabel},
  computed:{},
  methods:{
    handleQuery(){
      this.$emit("handleQuery",this.inputCarNo);
    },
    add(){
      this.$emit("add");
    },
    exportClick(){
      this.$emit("export");
    },
    edit(){
      this.$emit("edit");
    },
    del(){
      this.$emit("del");
    },
  },
  mounted(){},
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
</style>